import { render, staticRenderFns } from "./addOldUser.vue?vue&type=template&id=95c7f894&"
import script from "./addOldUser.vue?vue&type=script&lang=js&"
export * from "./addOldUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports